import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  allowedFileType_merchantDocuments,
  apiURL_provider,
  OnBoardingStepProps,
  ALERT_TITLES,
  ALERT_MESSAGES,
} from "../../../constants";
import {
  alertMessage,
  alertMessageWithCancel,
} from "../../../services/alertService";
import { FileUploadSignup } from "./molecules/FileUploadSignup";
import { Box, Typography } from "../../../styles/FileUpload";
import { setItemWithObject } from "../../../utils/cache/LocalStorage";
import DatePicker from "../../../components/common/datepicker";

import {
  ErrorText,
  FormContainer,
  FormGroup,
  FullWidthContainer,
  InputField,
  Label,
} from "../../../styles/PersonalInfoStep";
import axios from "axios";
import { refreshHeaderOptionToken } from "../../../utils/apis/api-header-option";
import { POST } from "../../../services/HTTPServices";
import {
  LoadingOverlay,
  LoadingSpinner,
  LoadingSpinnerIcon,
} from "../../../styles/loading";
import { StepFileUploadForm } from "../../../components/signup/StepFileUploadForm";

const DocumentUploadStep: React.FC<OnBoardingStepProps> = ({
  formData,
  onChange,
  onNext,
  onBack,
  onAssign,

  changedRole,
}) => {
  const navigate = useNavigate();
  interface FileItem {
    id: string;
    imagePath: File;
  }

  interface FileNameItem {
    id: string;
    imageName: string;
  }

  const [values, setValues] = React.useState<{
    sfaLicense: FileItem[];
    halalLicense: FileItem[];
    catalogue: FileItem[];
    store_cover_photo: FileItem[];
    store_cover_ar1_photo: FileItem[];
    letterOfAuth: FileItem[];
    nricFront: FileItem[];
    nricBack: FileItem[];

    liquorLicense: FileItem[];
    sfa_license_name: FileNameItem[];
    halal_license_name: FileNameItem[];
    store_cover_name: FileNameItem[];
    store_cover_ar1_name: FileNameItem[];
    catalogue_name: FileNameItem[];
    letterOfAuth_name: FileNameItem[];
    nricFront_name: FileNameItem[];
    nricBack_name: FileNameItem[];

    liquorLicense_name: FileNameItem[];
  }>({
    sfaLicense: [],
    halalLicense: [],
    catalogue: [],
    store_cover_photo: [],
    store_cover_ar1_photo: [],
    letterOfAuth: [],
    nricFront: [],
    nricBack: [],

    liquorLicense: [],
    sfa_license_name: [],
    halal_license_name: [],
    store_cover_name: [],
    store_cover_ar1_name: [],
    catalogue_name: [],
    letterOfAuth_name: [],
    nricFront_name: [],
    nricBack_name: [],

    liquorLicense_name: [],
  });

  const [loading, setLoading] = React.useState(false);
  const [tempToken, setTempToken] = React.useState("");
  const [submitBtnClick, setSubmitBtnClick] = React.useState(false);

  const [errors, setErrors] = React.useState<Record<string, boolean>>({
    sfaLicense: false,
    halalExpire: false,
    liquorExpire: false,
    nricFront: false,
    nricBack: false,
    letterOfAuth: false,
    storeCover: false,
    storeCoverAR1: false,
  });

  const [user, setUser] = React.useState<{
    sfaLicensePath: string[];
    sfaLicense: FileItem[];
    halalLicense: FileItem[];
    halalLicensePath: string[];
    cataloguePath: string[];
    catalogue: FileItem[];
    storeCoverPath: string[];
    storeCover: FileItem[];
    storeCoverAR1Path: string[];
    storeCoverAR1: FileItem[];
    letterOfAuth: FileItem[];
    letterOfAuthPath: string[];
    nricFront: FileItem[];
    nricFrontPath: string[];
    nricBack: FileItem[];
    nricBackPath: string[];

    liquorLicense: FileItem[];
    liquorLicensePath: string[];
    halalExpire: any;
    liquorExpire: any;
  }>({
    sfaLicensePath: [],
    sfaLicense: [],
    halalLicense: [],
    halalLicensePath: [],
    cataloguePath: [],
    catalogue: [],
    storeCoverPath: [],
    storeCover: [],
    storeCoverAR1Path: [],
    storeCoverAR1: [],
    letterOfAuth: [],
    letterOfAuthPath: [],
    nricFront: [],
    nricFrontPath: [],
    nricBack: [],
    nricBackPath: [],
    liquorLicense: [],
    liquorLicensePath: [],
    halalExpire: null,
    liquorExpire: null,
  });
  const [authUser, setAuthUser] = React.useState({ name: "", id: -1 });
  const [serviceProviderId, setServiceProviderId] = React.useState("");
  const [accounttype, setAccounttype] = React.useState("");

  var tempPaths: any[] = [];

  // Initialize KYB state from localStorage
  useEffect(() => {
    const files = JSON.parse(localStorage.getItem("files") || "null");
    if (files) {
      setValues(files);
    }

    const userFiles = JSON.parse(localStorage.getItem("files-user") || "null");
    if (userFiles) {
      setUser(userFiles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const tempUser = JSON.parse(localStorage.getItem("tempUser") || "null");
    if (tempUser) {
      tempUser.mobile = "+65" + tempUser.mobile;
      setAuthUser(tempUser);
      onAssign(tempUser);
      setErrors({
        sfaLicense: false,
        halalExpire: false,
        liquorExpire: false,
        nricFront: false,
        letterOfAuth: false,
        storeCover: false,
        storeCoverAR1: false,
      });
    }
    const serviceProviderId = localStorage.getItem("serviceProviderId") || "";
    if (serviceProviderId) {
      setServiceProviderId(serviceProviderId);
    }

    const accounttype_res = localStorage.getItem("accounttype") || "";
    if (accounttype_res) {
      setAccounttype(accounttype_res);
      setErrors({
        sfaLicense: true,
        halalExpire: true,
        liquorExpire: true,
        nricFront: true,
        letterOfAuth: accounttype_res === "business" ? true : false,
        storeCover: true,
        storeCoverAR1: true,
      });
    }
    const temp_token = localStorage.getItem("temp_token") || "";
    if (temp_token) {
      setTempToken(temp_token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const upload = () => {
    setSubmitBtnClick(true);
    if (!valid())
      alertMessage(ALERT_TITLES.WARNING, ALERT_MESSAGES.UPLOAD_REQUIRED);
    else uploadDocuments();
  };

  const uploadDocuments = async () => {
    setLoading(true);

    let url = "serviceprovider/UpdateServiceProvider";
    let auth: any = authUser;
    const savedCoord = JSON.parse(localStorage.getItem("saved_coord") || "{}");
    const lat = savedCoord?.lat || "";
    const lng = savedCoord?.lng || "";

    let temp = {
      id: parseInt(serviceProviderId) || "",
      firstName: auth.firstName || "",
      lastName: auth.lastName || "",
      name: auth.name || "",
      email: auth.email || "",
      mobile: auth.mobile || "",
      idType: "NRIC",
      hawkerId: auth.hawkerId,
      nricFront: user.nricFront,
      nricFrontPath: user.nricFrontPath,
      nricBack: user.nricBack,
      nricBackPath: user.nricBackPath,
      letterOfAuth: user.letterOfAuth,
      letterOfAuthPath: user.letterOfAuthPath,
      digitalCopies: [],
      digitalCopiesPath: [],

      sfaLicense: user.sfaLicense,
      sfaLicensePath: user.sfaLicensePath,
      halalLicense: user.halalLicense,
      halalLicensePath: user.halalLicensePath,
      storeCover: user.storeCover,
      storeCoverPath: user.storeCoverPath,
      catalogue: user.catalogue,
      cataloguePath: user.cataloguePath,
      storeCoverAR1: user.storeCoverAR1,
      storeCoverAR1Path: user.storeCoverAR1Path,
      halalExpire: user.halalExpire,
      liquorLicense: user.liquorLicense,
      liquorLicensePath: user.liquorLicensePath,
      liquorExpire: user.liquorExpire,

      shopName: auth.shopName,
      postcode: auth.postcode,
      city: auth.city,
      street: auth.street,
      building: auth.building,

      block: auth.block,
      floor: auth.floor,
      unit: auth.unit,
      latitude: lat ? lat + "" : "",
      longitude: lng ? lng + "" : "",

      entityName: auth.entityName || "",
      uen: auth.uen || "",
      signeeName: auth.signeeName || "",
      signeeNRIC: auth.signeeNRIC || "",

      companyName: auth.companyName || "",
      registrationNo: "",
      registrationDate: new Date().toISOString(),
      companyPhone: auth.companyPhone || "",

      companyEmail: auth.companyEmail || "",
      companyAddress: auth.companyAddress || "",
      businessType: auth.businessType || "",
      businessActivity: auth.businessActivity || "",
      businessActivity2: auth.businessActivity2 || "",
      website: auth.website || "",

      agreeTA: true,
      serviceProviderServices: [
        {
          serviceTypeId: 5,
        },
      ],
      isDeactivate: false,
      isDelete: false,
      createdDate: new Date().toISOString(),
      createdUserId: serviceProviderId || "",
      updatedUserId: serviceProviderId || "",
    };

    setTimeout(async () => {
      let res: any = await POST(url, temp, "provider", false, tempToken);

      if (res && res.status === 200) {
        setLoading(false);
        alertMessage(
          ALERT_TITLES.SUCCESS,
          ALERT_MESSAGES.DOCUMENT_UPLOAD_SUCCESS
        );
        postChecklist();
      } else {
        setLoading(false);

        if (res.status && res.status === 401) navigate("/unauthorized-page");
        else {
          alertMessage(ALERT_TITLES.ERROR, res.message);
          onNext({ type: "error", errMsg: res.message });
        }
      }
    }, 300);
  };

  const postChecklist = async () => {
    setLoading(true);
    let url = "onboardingcheck/UpdateOnboardingCheck";

    const skipKyb = localStorage.getItem("skipKyb") || "";

    let temp = {
      serviceProviderId: parseInt(serviceProviderId),
      personalInfo: 2,
      businessInfo: 2,
      kyb: skipKyb && skipKyb === "true" ? 0 : 2,
      fileUpload: 1,
      agreement: 0,
    };

    let res: any = await POST(url, temp, "provider", false, tempToken);

    if (res && res.status === 200) {
      onNext();
    } else {
      setLoading(false);
      if (res.status && res.status === 401) navigate("/unauthorized-page");
      else {
        alertMessage(ALERT_TITLES.ERROR, res.message);
      }
    }
  };

  const valid = () => {
    if (
      !user.sfaLicense ||
      user.sfaLicense.length === 0 ||
      !user.storeCover ||
      user.storeCoverPath.length === 0 ||
      !user.storeCoverAR1 ||
      user.storeCoverAR1Path.length === 0 ||
      !user.nricFrontPath ||
      user.nricFrontPath.length === 0 ||
      (accounttype === "business" &&
        (!user.letterOfAuthPath || user.letterOfAuthPath.length === 0)) ||
      (user.halalLicensePath?.length > 0 &&
        (!user.halalExpire || user.halalExpire === "")) ||
      (user.liquorLicensePath?.length > 0 &&
        (!user.liquorExpire || user.liquorExpire === ""))
    )
      return false;
    else return true;
  };

  const handleChangeSFALicense = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }

    setLoading(true);
    const file: any = e.target.files;

    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    if (
      !fileExtension ||
      !allowedFileType_merchantDocuments.includes(`.${fileExtension}`)
    ) {
      alertMessage(ALERT_TITLES.WARNING, ALERT_MESSAGES.INVALID_FILE_FORMAT);
      setLoading(false);
      return;
    }

    const fileInfo: FileNameItem = {
      id: "0",
      imageName: file.name,
    };

    const filePath: FileItem = {
      id: "0",
      imagePath: file,
    };

    // Prepare upload for sfaLicense only
    prepareUpload(file.name, file, "sfaLicense", 0);

    // Update values state - only update sfaLicense related fields
    const newValues = {
      ...values,
      sfaLicense: [filePath],
      sfa_license_name: [fileInfo],
    };

    setValues(newValues);

    // Update user state - only update sfaLicense
    const updatedUser = {
      ...user,
      sfaLicense: [filePath],
    };

    setUser(updatedUser);

    // Save to localStorage
    setItemWithObject("files", newValues);
    setItemWithObject("files-user", updatedUser);

    // Update tempUser in localStorage - only update sfaLicense
    const tempUser = JSON.parse(localStorage.getItem("tempUser") || "null");
    if (tempUser) {
      localStorage.setItem(
        "tempUser",
        JSON.stringify({
          ...tempUser,
          sfaLicense: [fileInfo],
        })
      );
    }

    setLoading(false);
  };

  const backfromPickerHalal = (date: any) => {
    // Convert the selected date to local timezone
    var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
    let selectedDate = new Date(date - tzoffset);
    let bDay = selectedDate.toISOString().slice(0, -1);

    // Get current date for comparison (without time)
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day

    // Reset selected date time to start of day for fair comparison
    const selectedDateOnly = new Date(selectedDate);
    selectedDateOnly.setHours(0, 0, 0, 0);

    setUser({
      ...user,
      halalExpire: bDay,
    });

    setErrors((prev) => ({
      ...prev,
      halalExpire: selectedDateOnly < today ? true : false,
    }));
  };

  const backfromPickerLiquor = (date: any) => {
    // Convert the selected date to local timezone
    var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
    let selectedDate = new Date(date - tzoffset);
    let bDay = selectedDate.toISOString().slice(0, -1);

    // Get current date for comparison (without time)
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day

    // Reset selected date time to start of day for fair comparison
    const selectedDateOnly = new Date(selectedDate);
    selectedDateOnly.setHours(0, 0, 0, 0);

    setUser({
      ...user,
      liquorExpire: bDay,
    });

    setErrors((prev) => ({
      ...prev,
      liquorExpire: selectedDateOnly < today ? true : false,
    }));
  };

  const handleChangeHalalLicense = (e: any) => {
    setLoading(true);
    let images: any = [];
    let paths: any = [];
    const fileExtension = e.target.files.name.split(".").pop()?.toLowerCase();
    if (
      !fileExtension ||
      !allowedFileType_merchantDocuments.includes(`.${fileExtension}`)
    ) {
      alertMessage(ALERT_TITLES.WARNING, ALERT_MESSAGES.INVALID_FILE_FORMAT);
      setLoading(false);
    } else {
      prepareUpload(e.target.files.name, e.target.files, "halalLicense", 0);
      let id = 0;
      images.push({
        id: id.toString(),
        imageName: e.target.files.name,
      });
      paths.push({ id: id.toString(), imagePath: e.target.files });
      setValues({
        ...values,
        halalLicense: paths,
        halal_license_name: images,
      });
      setItemWithObject("files", values);
    }
  };

  const handleChangeLetterOfAuth = (e: any) => {
    setLoading(true);
    let images: any = [];
    let paths: any = [];
    const fileExtension = e.target.files.name.split(".").pop()?.toLowerCase();
    if (
      !fileExtension ||
      !allowedFileType_merchantDocuments.includes(`.${fileExtension}`)
    ) {
      alertMessage(ALERT_TITLES.WARNING, ALERT_MESSAGES.INVALID_FILE_FORMAT);
      setLoading(false);
    } else {
      prepareUpload(e.target.files.name, e.target.files, "letterOfAuth", 0);
      let id = 0;
      images.push({
        id: id.toString(),
        imageName: e.target.files.name,
      });
      paths.push({ id: id.toString(), imagePath: e.target.files });
      setValues({
        ...values,
        letterOfAuth: paths,
        letterOfAuth_name: images,
      });
      setItemWithObject("files", values);
    }
  };

  const handleChangeLiquorLicense = (e: any) => {
    setLoading(true);

    let images: any = [];
    let paths: any = [];
    const fileExtension = e.target.files.name.split(".").pop()?.toLowerCase();
    if (
      !fileExtension ||
      !allowedFileType_merchantDocuments.includes(`.${fileExtension}`)
    ) {
      alertMessage(ALERT_TITLES.WARNING, ALERT_MESSAGES.INVALID_FILE_FORMAT);
      setLoading(false);
    } else {
      prepareUpload(e.target.files.name, e.target.files, "liquorLicense", 0);
      let id = 0;
      images.push({
        id: id.toString(),
        imageName: e.target.files.name,
      });
      paths.push({ id: id.toString(), imagePath: e.target.files });
      setValues({
        ...values,
        liquorLicense: paths,
        liquorLicense_name: images,
      });
      setItemWithObject("files", values);
    }
  };

  const handleChangeNRIC = (e: any) => {
    setLoading(true);

    let images: any = [];
    let paths: any = [];
    const fileExtension = e.target.files.name.split(".").pop()?.toLowerCase();
    if (
      !fileExtension ||
      !allowedFileType_merchantDocuments.includes(`.${fileExtension}`)
    ) {
      alertMessage(ALERT_TITLES.WARNING, ALERT_MESSAGES.INVALID_FILE_FORMAT);
      setLoading(false);
    } else {
      prepareUpload(e.target.files.name, e.target.files, "nricFront", 0);
      let id = 0;
      images.push({
        id: id.toString(),
        imageName: e.target.files.name,
      });
      paths.push({ id: id.toString(), imagePath: e.target.files });
      setValues({
        ...values,
        nricFront: paths,
        nricFront_name: images,
      });
      setItemWithObject("files", values);
    }
  };

  const handleChangeNRICBack = (e: any) => {
    setLoading(true);

    let images: any = [];
    let paths: any = [];
    const fileExtension = e.target.files.name.split(".").pop()?.toLowerCase();
    if (
      !fileExtension ||
      !allowedFileType_merchantDocuments.includes(`.${fileExtension}`)
    ) {
      alertMessage(ALERT_TITLES.WARNING, ALERT_MESSAGES.INVALID_FILE_FORMAT);
      setLoading(false);
    } else {
      prepareUpload(e.target.files.name, e.target.files, "nricBack", 0);
      let id = 0;
      images.push({
        id: id.toString(),
        imageName: e.target.files.name,
      });
      paths.push({ id: id.toString(), imagePath: e.target.files });
      setValues({
        ...values,
        nricBack: paths,
        nricBack_name: images,
      });
      setItemWithObject("files", values);
    }
  };

  // const handleChangeNRICMultiple = (e: any) => {
  //   setLoading(true);
  //   let images: any = [];
  //   let paths: any = [];

  //   if (e.target.files.length > 0) {
  //     for (let i = 0; i < e.target.files.length; i++) {
  //       const fileExtension = e.target.files[i].name
  //         .split(".")
  //         .pop()
  //         ?.toLowerCase();
  //       if (
  //         !fileExtension ||
  //         !allowedFileType_merchantDocuments.includes(`.${fileExtension}`)
  //       ) {
  //         alertMessage(
  //           ALERT_TITLES.WARNING,
  //           ALERT_MESSAGES.INVALID_FILE_FORMAT
  //         );
  //         setLoading(false);
  //       } else {
  //         prepareUpload(
  //           e.target.files[i].name,
  //           e.target.files[i],
  //           "nricBack",
  //           0
  //         );
  //         let id = i;
  //         images.push({
  //           id: id.toString(),
  //           imageName: e.target.files[i].name,
  //         });
  //         paths.push({ id: id.toString(), imagePath: e.target.files });
  //         if (i === e.target.files.length - 1) {
  //           setValues({
  //             ...values,
  //             nricBack: paths,
  //             nricBack_name: images,
  //           });
  //           setItemWithObject("files", values);
  //         }
  //       }
  //     }
  //   }
  // };

  const handleChangeStoreCoverPhoto = (e: any) => {
    setLoading(true);

    let images: any = [];
    let paths: any = [];
    const fileExtension = e.target.files.name.split(".").pop()?.toLowerCase();
    if (
      !fileExtension ||
      !allowedFileType_merchantDocuments.includes(`.${fileExtension}`)
    ) {
      alertMessage(ALERT_TITLES.WARNING, ALERT_MESSAGES.INVALID_FILE_FORMAT);
      setLoading(false);
    } else {
      prepareUpload(
        e.target.files.name,
        e.target.files,
        "store_cover_photo",
        0
      );
      let id = 0;
      images.push({
        id: id.toString(),
        imageName: e.target.files.name,
      });
      paths.push({ id: id.toString(), imagePath: e.target.files });
      setValues({
        ...values,
        store_cover_photo: paths,
        store_cover_name: images,
      });
      setItemWithObject("files", values);
    }
  };

  const handleChangeStoreCoverAR1Photo = (e: any) => {
    setLoading(true);

    let images: any = [];
    let paths: any = [];
    const fileExtension = e.target.files.name.split(".").pop()?.toLowerCase();
    if (
      !fileExtension ||
      !allowedFileType_merchantDocuments.includes(`.${fileExtension}`)
    ) {
      alertMessage(ALERT_TITLES.WARNING, ALERT_MESSAGES.INVALID_FILE_FORMAT);
      setLoading(false);
    } else {
      prepareUpload(
        e.target.files.name,
        e.target.files,
        "store_cover_ar1_photo",
        0
      );
      let id = 0;
      images.push({
        id: id.toString(),
        imageName: e.target.files.name,
      });
      paths.push({ id: id.toString(), imagePath: e.target.files });
      setValues({
        ...values,
        store_cover_ar1_photo: paths,
        store_cover_ar1_name: images,
      });
      setItemWithObject("files", values);
    }
  };

  const getBase64 = (file: any) => {
    return new Promise((resolve) => {
      let reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };
    });
  };

  const prepareUpload = (
    fileName: string,
    file: any,
    type: string,
    id: number
  ) => {
    getBase64(file)
      .then((result) => {
        file["base64"] = result;
        let temp = file.base64.split(",");
        uploadFile(fileName, temp[1], type, id);
      })
      .catch((err) => {
        alertMessage(
          ALERT_TITLES.ERROR,
          "Converting Base 64 of " + { fileName } + " was failed."
        );

        setLoading(false);
      });
  };

  const uploadFile = async (
    fileName: string,
    document: string,
    type: string,
    id: number
  ) => {
    let headers = refreshHeaderOptionToken();
    let url = "serviceprovider/FileUpload";
    let fileParam = {
      fileName: fileName,
      document: document,
    };

    axios
      .post(`${apiURL_provider}/${url}`, fileParam, headers.optionPlane)
      .then(({ data }) => {
        try {
          tempPaths.push({ id: id, path: data.filePath, name: data.fileName });
          setDataUser(type);
          setLoading(false);
        } catch {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
        if (error?.response?.status && error?.response?.status === 401)
          navigate("/unauthorized-page");
        else {
          alert();
          alertMessage(
            ALERT_TITLES.ERROR,
            "Uploading " + { fileName } + " was failed."
          );
        }
      });
  };

  const setDataUser = async (type: string) => {
    switch (type) {
      case "sfaLicense": {
        let paths: any = [];
        let images: any = [];
        for (let i = 0; i < tempPaths.length; i++) {
          paths.push({ Id: tempPaths[i].id, ImagePath: tempPaths[i].path, status : 1 });
          images.push({ Id: tempPaths[i].id, ImageName: tempPaths[i].name });

          if (i === tempPaths.length - 1) {
            const updatedUser = {
              ...user,
              sfaLicensePath: paths,
              sfaLicense: images,
            };

            await setUser(updatedUser);
            setItemWithObject("files-user", updatedUser);
            setErrors((prev) => ({
              ...prev,
              sfaLicense: tempPaths.length > 0 ? true : false,
            }));
          }
        }
        break;
      }
      case "halalLicense": {
        let paths: any = [];
        let images: any = [];
        for (let i = 0; i < tempPaths.length; i++) {
          paths.push({ Id: tempPaths[i].id, ImagePath: tempPaths[i].path, status : 1 });
          images.push({ Id: tempPaths[i].id, ImageName: tempPaths[i].name });

          if (i === tempPaths.length - 1) {
            const updatedUser = {
              ...user,
              halalLicensePath: paths,
              halalLicense: images,
            };

            await setUser(updatedUser);
            setItemWithObject("files-user", updatedUser);
            setErrors((prev) => ({
              ...prev,
              halalLicense: tempPaths.length > 0 ? true : false,
            }));
          }
        }
        break;
      }

      case "liquorLicense": {
        let paths: any = [];
        let images: any = [];
        for (let i = 0; i < tempPaths.length; i++) {
          paths.push({ Id: tempPaths[i].id, ImagePath: tempPaths[i].path, status : 1 });
          images.push({ Id: tempPaths[i].id, ImageName: tempPaths[i].name });

          if (i === tempPaths.length - 1) {
            const updatedUser = {
              ...user,
              liquorLicensePath: paths,
              liquorLicense: images,
            };

            await setUser(updatedUser);
            setItemWithObject("files-user", updatedUser);
            setErrors((prev) => ({
              ...prev,
              liquorLicense: tempPaths.length > 0 ? true : false,
            }));
          }
        }
        break;
      }
      case "letterOfAuth": {
        let paths: any = [];
        let images: any = [];
        for (let i = 0; i < tempPaths.length; i++) {
          paths.push({ Id: tempPaths[i].id, ImagePath: tempPaths[i].path, status : 1 });
          images.push({ Id: tempPaths[i].id, ImageName: tempPaths[i].name });
          if (i === tempPaths.length - 1) {
            const updatedUser = {
              ...user,
              letterOfAuthPath: paths,
              letterOfAuth: images,
            };

            await setUser(updatedUser);
            setItemWithObject("files-user", updatedUser);
            setErrors((prev) => ({
              ...prev,
              letterOfAuth: tempPaths.length > 0 ? true : false,
            }));
          }
        }
        break;
      }
      case "nricFront": {
        let paths: any = [];
        let images: any = [];
        for (let i = 0; i < tempPaths.length; i++) {
          paths.push({ Id: tempPaths[i].id, ImagePath: tempPaths[i].path, status : 1 });
          images.push({ Id: tempPaths[i].id, ImageName: tempPaths[i].name });
          if (i === tempPaths.length - 1) {
            const updatedUser = {
              ...user,
              nricFrontPath: paths,
              nricFront: images,
            };

            await setUser(updatedUser);
            setItemWithObject("files-user", updatedUser);
            setErrors((prev) => ({
              ...prev,
              nricFront: tempPaths.length > 0 ? true : false,
            }));
          }
        }
        break;
      }
      case "nricBack": {
        let paths: any = [];
        let images: any = [];
        for (let i = 0; i < tempPaths.length; i++) {
          paths.push({ Id: tempPaths[i].id, ImagePath: tempPaths[i].path, status : 1 });
          images.push({ Id: tempPaths[i].id, ImageName: tempPaths[i].name });
          if (i === tempPaths.length - 1) {
            const updatedUser = {
              ...user,
              nricBackPath: paths,
              nricBack: images,
            };

            await setUser(updatedUser);
            setItemWithObject("files-user", updatedUser);
            setErrors((prev) => ({
              ...prev,
              nricBack: tempPaths.length > 0 ? true : false,
            }));
          }
        }
        break;
      }
      case "store_cover_photo": {
        let paths: any = [];
        let images: any = [];
        for (let i = 0; i < tempPaths.length; i++) {
          paths.push({ Id: tempPaths[i].id, ImagePath: tempPaths[i].path, status : 1 });
          images.push({ Id: tempPaths[i].id, ImageName: tempPaths[i].name });
          if (i === tempPaths.length - 1) {
            const updatedUser = {
              ...user,
              storeCoverPath: paths,
              storeCover: images,
            };

            await setUser(updatedUser);
            setItemWithObject("files-user", updatedUser);
            setErrors((prev) => ({
              ...prev,
              storeCover: tempPaths.length > 0 ? true : false,
            }));
          }
        }
        break;
      }
      case "store_cover_ar1_photo": {
        let paths: any = [];
        let images: any = [];
        for (let i = 0; i < tempPaths.length; i++) {
          paths.push({ Id: tempPaths[i].id, ImagePath: tempPaths[i].path, status : 1 });
          images.push({ Id: tempPaths[i].id, ImageName: tempPaths[i].name });

          if (i === tempPaths.length - 1) {
            const updatedUser = {
              ...user,
              storeCoverAR1Path: paths,
              storeCoverAR1: images,
            };

            await setUser(updatedUser);
            setItemWithObject("files-user", updatedUser);
            setErrors((prev) => ({
              ...prev,
              storeCoverAR1: tempPaths.length > 0 ? true : false,
            }));
          }
        }
        break;
      }
      case "catalogue": {
        let paths: any = [];
        let images: any = [];
        for (let i = 0; i < tempPaths.length; i++) {
          paths.push({ Id: tempPaths[i].id, ImagePath: tempPaths[i].path, status : 1 });
          images.push({ Id: tempPaths[i].id, ImageName: tempPaths[i].name });

          if (i === tempPaths.length - 1) {
            const updatedUser = {
              ...user,
              cataloguePath: paths,
              catalogue: images,
            };

            await setUser(updatedUser);
            setItemWithObject("files-user", updatedUser);
            setErrors((prev) => ({
              ...prev,
              catalogue: tempPaths.length > 0 ? true : false,
            }));
          }
        }
        break;
      }
    }

    setErrors((prev) => ({
      ...prev,
      [type]: tempPaths.length > 0 ? false : true,
    }));
  };

  const handleDelete = async (type: string) => {
    const isDelete = await alertMessageWithCancel(
      ALERT_TITLES.CONFIRMATION,
      ALERT_MESSAGES.DELETE_CONFIRMATION,
      "Delete",
      "Cancel"
    );
    if (isDelete) {
      deleteFile(type);
    }
  };

  const deleteFile = async (type: string) => {
    switch (type) {
      case "sfaLicense": {
        await setUser({
          ...user,
          sfaLicensePath: [],
          sfaLicense: [],
        });
        setItemWithObject("files-user", user);
        setErrors((prev) => ({
          ...prev,
          sfaLicense: false,
        }));
        break;
      }
      case "halalLicense": {
        await setUser({
          ...user,
          halalLicensePath: [],
          halalLicense: [],
        });
        setItemWithObject("files-user", user);
        setErrors((prev) => ({
          ...prev,
          halalExpire: false,
        }));
        break;
      }

      case "liquorLicense": {
        await setUser({
          ...user,
          liquorLicensePath: [],
          liquorLicense: [],
        });
        setItemWithObject("files-user", user);
        setErrors((prev) => ({
          ...prev,
          liquorExpire: false,
        }));
        break;
      }
      case "letterOfAuth": {
        await setUser({
          ...user,
          letterOfAuthPath: [],
          letterOfAuth: [],
        });
        setItemWithObject("files-user", user);
        break;
      }
      case "nricFront": {
        await setUser({
          ...user,
          nricFrontPath: [],
          nricFront: [],
        });
        setItemWithObject("files-user", user);
        setErrors((prev) => ({
          ...prev,
          nricFront: true,
        }));
        break;
      }
      case "store_cover_photo": {
        await setUser({
          ...user,
          storeCoverPath: [],
          storeCover: [],
        });
        setItemWithObject("files-user", user);
        break;
      }
      case "store_cover_ar1_photo": {
        await setUser({
          ...user,
          storeCoverAR1Path: [],
          storeCoverAR1: [],
        });
        setItemWithObject("files-user", user);
        break;
      }
      case "catalogue": {
        await setUser({
          ...user,
          cataloguePath: [],
          catalogue: [],
        });
        setItemWithObject("files-user", user);
        break;
      }
    }
  };

  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}
      <FormContainer>
        <StepFileUploadForm
          onNext={upload}
          onBack={onBack}
          onSkip={() => onNext("nextKyb")}
        >
          <Box>
            <Typography size="large" className="mb-16">
              Almost there, please submit your id for verification
            </Typography>
            <Typography size="large" className="mb-32">
              Please upload Store License and Certificate
            </Typography>
          </Box>

          <FileUploadSignup
            key={
              user.sfaLicense?.length
                ? `sfa-${user.sfaLicense.length}`
                : "sfa-empty"
            }
            label="Singapore Food Agency (SFA) License"
            files={user.sfaLicense}
            onChange={handleChangeSFALicense}
            onDelete={() => handleDelete("sfaLicense")}
            inputId="upload-button1"
            required
          />
          {submitBtnClick && errors.sfaLicense && (
            <ErrorText>
              Singapore Food Agency (SFA) License is required.
            </ErrorText>
          )}

          <FileUploadSignup
            key={"halal"}
            label="Halal Certificate"
            files={user.halalLicense}
            onChange={handleChangeHalalLicense}
            onDelete={() => handleDelete("halalLicense")}
            inputId="upload-button2"
          />

          {user.halalLicense?.length > 0 && (
            <>
              <FormGroup className="mb-16">
                <FullWidthContainer>
                  <Label>Halal Certificate Expired Date*</Label>
                  <InputField>
                    <DatePicker
                      label=""
                      value={user.halalExpire}
                      type={"birthday"}
                      onChange={backfromPickerHalal}
                      disablePast={true}
                    />
                  </InputField>
                </FullWidthContainer>
              </FormGroup>
              {submitBtnClick && errors.halalExpire && (
                <ErrorText>
                  Halal Certificate Expired Date is required and not the past.
                </ErrorText>
              )}
            </>
          )}

          <FileUploadSignup
            key={"liquorLicense"}
            label="Liquor License"
            files={user.liquorLicense}
            onChange={handleChangeLiquorLicense}
            onDelete={() => handleDelete("liquorLicense")}
            inputId="upload-button7"
          />

          {user.liquorLicense?.length > 0 && (
            <>
              <FormGroup className="mb-16">
                <FullWidthContainer>
                  <Label>Liquor License Expired Date*</Label>
                  <InputField>
                    <DatePicker
                      value={user.liquorExpire}
                      type={"birthday"}
                      label={""}
                      onChange={backfromPickerLiquor}
                      disablePast={true}
                    />
                  </InputField>
                </FullWidthContainer>
              </FormGroup>
              {submitBtnClick && errors.liquorExpire && (
                <ErrorText>
                  Liquor License Expired Date is required and not the past.
                </ErrorText>
              )}
            </>
          )}

          <FileUploadSignup
            key={"nricFront"}
            label="NRIC(Front)"
            files={user.nricFront}
            onChange={handleChangeNRIC}
            onDelete={() => handleDelete("nricFront")}
            inputId="upload-button8"
            required
          />
          {submitBtnClick && errors.nricFront && (
            <ErrorText>NRIC(Front) is required.</ErrorText>
          )}

          <FileUploadSignup
            key={"nricBack"}
            label="NRIC(Back)"
            files={user.nricBack}
            onChange={handleChangeNRICBack}
            onDelete={() => handleDelete("nricBack")}
            inputId="upload-button9"
            required
          />
          {submitBtnClick && errors.nricBack && (
            <ErrorText>NRIC(Back) is required.</ErrorText>
          )}

          {accounttype === "business" && (
            <>
              <Typography size="large" className="mb-16">
                If your company is corporate,
              </Typography>

              <FileUploadSignup
                key={"letterOfAuth"}
                label="Biz File"
                files={user.letterOfAuth}
                onChange={handleChangeLetterOfAuth}
                onDelete={() => handleDelete("letterOfAuth")}
                inputId="upload-button6"
                required
              />
              {submitBtnClick && errors.letterOfAuth && (
                <ErrorText>Biz File is required.</ErrorText>
              )}
            </>
          )}

          <Typography size="large" className="mb-16">
            Please upload Stall Cover Pictures
          </Typography>

          <FileUploadSignup
            key={"storecover"}
            label="Store Cover (1:1)"
            files={user.storeCover}
            onChange={handleChangeStoreCoverPhoto}
            onDelete={() => handleDelete("store_cover_photo")}
            inputId="upload-button4"
            required
          />
          {submitBtnClick && errors.storeCover && (
            <ErrorText>Store Cover (1:1) is required.</ErrorText>
          )}

          <FileUploadSignup
            key={"storecoverAR1"}
            label="Store Cover (16:9)"
            files={user.storeCoverAR1}
            onChange={handleChangeStoreCoverAR1Photo}
            onDelete={() => handleDelete("store_cover_ar1_photo")}
            inputId="upload-button5"
            required
          />
          {submitBtnClick && errors.storeCoverAR1 && (
            <ErrorText>Store Cover (16:9) is required.</ErrorText>
          )}
        </StepFileUploadForm>
      </FormContainer>
    </>
  );
};

export default DocumentUploadStep;
